import { render, staticRenderFns } from "./kr-toggle.vue?vue&type=template&id=c270a1ca&scoped=true&"
import script from "./kr-toggle.vue?vue&type=script&lang=js&"
export * from "./kr-toggle.vue?vue&type=script&lang=js&"
import style0 from "./kr-toggle.vue?vue&type=style&index=0&id=c270a1ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270a1ca",
  null
  
)

export default component.exports